import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityAppIMOverviewVO } from '../Type/PackEntityAppIMOverviewVO'

interface DataModel {
	aid?: string
	cid?: string
}

/**
 *	查询IM总览
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.aid] 应用id
 * @param {string} [data.cid] 企业id
 */

export function funcimoverview(data: DataModel, options: IRequestOptionsWithPass): Promise<PackEntityAppIMOverviewVO>
export function funcimoverview(
	data: DataModel,
	options?: IRequestOptions,
): Promise<PackEntityAppIMOverviewVO extends { msg: unknown } ? PackEntityAppIMOverviewVO['msg'] : undefined>
export function funcimoverview(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { aid, cid } = data
	return net('/frontApi/app/func/im/overview', {
		method: 'post',
		params: {
			aid,
			cid,
		},

		...(options || {}),
	})
}
